var _path, _rect, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 556,
    height: 324,
    viewBox: "0 0 556 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.261 84.2832C544.232 79.0225 554.564 82.8795 558.297 92.8385C562.03 102.798 557.739 115.18 548.768 120.44C417.084 197.4 376.917 142.591 335.927 86.7092C196.74 -103.087 84.201 244.1 -76.1421 25.4624C-108.787 -19.067 -140.826 -62.7524 -247.735 -0.252012C-256.706 5.00874 -267.039 1.1517 -270.772 -8.80729C-274.505 -18.7663 -270.213 -31.1485 -261.242 -36.4093C-129.559 -113.368 -89.3919 -58.5599 -48.401 -2.67794C90.7856 187.118 203.324 -160.069 363.602 58.5503C396.313 103.098 428.351 146.784 535.261 84.2832ZM-97.5206 -529.334C-106.492 -524.073 -116.824 -527.93 -120.557 -537.889C-124.29 -547.848 -119.999 -560.23 -111.028 -565.491C20.6557 -642.45 60.8226 -587.642 101.813 -531.76C241 -341.964 353.539 -689.151 513.817 -470.532C546.462 -426.002 578.5 -382.317 685.41 -444.817C694.381 -450.078 704.713 -446.221 708.446 -436.262C712.179 -426.303 707.888 -413.921 698.917 -408.66C567.233 -331.701 527.067 -386.509 486.076 -442.391C346.954 -632.168 234.393 -284.904 74.0723 -503.62C41.4272 -548.149 9.38885 -591.834 -97.5206 -529.334ZM-147.592 -352.973C-156.563 -347.712 -166.896 -351.57 -170.629 -361.529C-174.362 -371.488 -170.07 -383.87 -161.099 -389.131C-29.4158 -466.09 10.7511 -411.281 51.742 -355.399C190.929 -165.604 303.467 -512.79 463.745 -294.171C496.391 -249.642 528.429 -205.956 635.338 -268.457C644.309 -273.717 654.642 -269.86 658.375 -259.901C662.108 -249.942 657.816 -237.56 648.845 -232.299C517.162 -155.34 476.995 -210.149 436.004 -266.031C296.883 -455.808 184.322 -108.543 24.0008 -327.259C-8.64434 -371.788 -40.6826 -415.474 -147.592 -352.973ZM-197.664 -176.613C-206.635 -171.352 -216.967 -175.209 -220.7 -185.168C-224.433 -195.127 -220.142 -207.509 -211.171 -212.77C-79.4873 -289.729 -39.3204 -234.921 1.67047 -179.039C140.857 10.7571 253.396 -336.43 413.674 -117.81C446.319 -73.281 478.357 -29.5956 585.267 -92.096C594.238 -97.3567 604.57 -93.4996 608.303 -83.5406C612.036 -73.5816 607.745 -61.1994 598.774 -55.9386C467.09 21.0205 426.924 -33.788 385.933 -89.6699C246.811 -279.447 134.25 67.8175 -26.0707 -150.898C-58.7158 -195.428 -90.7541 -239.113 -197.664 -176.613Z",
    fill: "#FFB81C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -121.231,
    y: -551.218,
    width: 833.887,
    height: 447.593,
    transform: "rotate(15.8501 -121.231 -551.218)",
    fill: "#FFB81C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.5222,
    cy: -25.6093,
    rx: 139.532,
    ry: 95.2118,
    transform: "rotate(15.8501 44.5222 -25.6093)",
    fill: "#FFB81C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 447.635,
    cy: 37.3126,
    rx: 104.442,
    ry: 93.7394,
    transform: "rotate(15.8501 447.635 37.3126)",
    fill: "#FFB81C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRegister);
export default __webpack_public_path__ + "static/media/imageRegister.96aa5ac2dfcfbe063dce4db1baa635cc.svg";
export { ForwardRef as ReactComponent };